import { Month as CeresMonth } from '@ceres/domain';
import { TranslateService } from '@ngx-translate/core';
import { Week } from './week';

export class Month implements CeresMonth {
    TitleDE: string;
    TitleEN: string;
    Date: Date;
    Value: string;
    Weeks: Week[];
    CalendarWeeks: Week[];

    constructor(
        private translate: TranslateService,
        object?: Partial<Month>
    ) {
        Object.assign(this, object);
    }

    public title?(): string {
        return this.translate.getCurrentLang() === 'en' ? this.TitleEN : this.TitleDE;
    }
}
